import { createAction, createReducer } from '@reduxjs/toolkit';

import { type CurrentStepActionParams, type OnboardingState, type ShareHintStepParams, Step } from './onboardingSteps.types';

export const setCurrentStep = createAction<CurrentStepActionParams>('onboarding/setCurrentStep');
export const expandOnboardingPanel = createAction('onboarding/expandOnboardingPanel');
export const collapseOnboardingPanel = createAction('onboarding/collapseOnboardingPanel');
export const showOnboardingPanel = createAction('onboarding/showOnboardingPanel');
export const hideOnboardingPanel = createAction('onboarding/hideOnboardingPanel');
export const showHintForCurrentStep = createAction('onboarding/showHintForCurrentStep');
export const setHintForShareStep = createAction<ShareHintStepParams>('onboarding/setHintForShareStep');
export const closeShareHint = createAction('onboarding/closeShareHint');
export const clearHint = createAction('onboarding/clearHint');
export const setInitialized = createAction('onboarding/setInitialized');

const INITIAL_STATE: OnboardingState = {
    isOpen: false,
    isVisible: false,
    isInitialized: false,
    currentStepIndex: 0,
    hints: {
        upload: false,
        shareButtonId: null,
        download: false,
        subscription: false,
    },
};

export const onboardingStepsReducer = createReducer(INITIAL_STATE, {
    [setCurrentStep.type]: (state, action) => {
        const { step } = action.payload;

        if (step >= Step.UPLOAD && step <= Step.ACHIEVEMENT) {
            state.currentStepIndex = step;
            state.isOpen = !!action.payload.isOpen;
        }
    },
    [expandOnboardingPanel.type]: (state) => {
        state.isOpen = true;
    },
    [collapseOnboardingPanel.type]: (state) => {
        state.isOpen = false;
    },
    [showOnboardingPanel.type]: (state) => {
        state.isVisible = true;
    },
    [hideOnboardingPanel.type]: (state) => {
        state.isVisible = false;
    },
    [showHintForCurrentStep.type]: (state) => {
        if (state.currentStepIndex === Step.UPLOAD) {
            state.hints = {
                ...INITIAL_STATE.hints,
                upload: true,
            };
        }

        if (state.currentStepIndex === Step.DOWNLOAD_APP) {
            state.hints = {
                ...INITIAL_STATE.hints,
                download: true,
            };
        }
        if (state.currentStepIndex === Step.ACHIEVEMENT) {
            state.hints = {
                ...INITIAL_STATE.hints,
                subscription: true,
            };
        }
    },
    [setHintForShareStep.type]: (state, action) => {
        if (state.currentStepIndex === Step.SHARE) {
            state.hints = {
                ...INITIAL_STATE.hints,
                shareButtonId: action.payload.itemId,
            };
        }
    },
    [closeShareHint.type]: (state) => {
        state.hints = {
            ...INITIAL_STATE.hints,
            shareButtonId: null,
        };
    },
    [setInitialized.type]: (state) => {
        state.isInitialized = true;
    },
});
